module.exports = __webpack_public_path__ + "img/logo.e60799c3.png";